<script lang="ts">
  import ListAlert from '$shared/atoms/ListAlert/ListAlert.svelte';
  import NewListAlert from '$shared/atoms/_ListAlert/ListAlert.svelte';
  import { transformListKey } from '$shared/helpers/ListKeyFormat';
  import { isNoLableKey } from '$shared/helpers/utils';
  import EditableListRow from '$shared/molecules/EditableListRow/EditableListRow.svelte';
  import IconWithTooltip from './partials/IconWithTooltip.svelte';
  import ListValue from './partials/ListValue.svelte';

  interface Props {
    list?: IDataList;
    problems?: string[];
    style?: string;
    onevent?: (payload: any) => void;
  }

  let { list = {}, problems = [], style = '', onevent }: Props = $props();

  const cleanUpList = (list = {}) => {
    const tempList = { ...list };
    Object.keys(tempList).forEach((key) => {
      if (key.indexOf('__') === 0) {
        delete tempList[key];
      }
    });
    return tempList;
  };
</script>

{#each Object.entries(cleanUpList(list)) as [key, value], index}
  <div
    class="list-i {style}"
    class:noPad={isNoLableKey(key)}
    class:odd={(index + 1) % 2 !== 0}
    class:editable={value?.isEditable}
  >
    {#if !isNoLableKey(key)}
      <div data-cy={`${key}-k`} class="key" class:required={value?.isRequired}>
        {transformListKey(key)}
      </div>
    {/if}
    <EditableListRow active={value?.isEditable} option={value?.option} {onevent}>
      <ListValue {key} value={value?.isEditable ? value?.actualValue : value} {problems} {onevent} />
    </EditableListRow>
    {#if value?.icon}
      <IconWithTooltip {value} />
    {/if}
  </div>
  {#if value && value.alert}
    <ListAlert alert={value.alert} {onevent} />
  {/if}
  {#if value && value.newAlerts && Array.isArray(value.newAlerts)}
    {#each value.newAlerts as alert (alert.saltString)}
      <NewListAlert {alert} {onevent} />
    {/each}
  {/if}
{:else}
  <div class="empty">No Data Found</div>
{/each}

<style>
  .list-i {
    display: flex;
    align-items: flex-start;
    padding: 12px 16px;
    line-height: 20px;
    color: var(--grey-dark);
  }
  .list-i.odd {
    background-color: var(--grey-bg) !important;
  }
  .list-i.editable {
    padding: 8px 12px;
  }
  .list-i .key {
    width: 150px;
    flex-shrink: 0;
    margin-right: 16px;
    overflow: hidden;
    color: var(--black);
    font-weight: 500;
  }
  .list-i.editable .key {
    padding: 5px;
  }

  .list-i .key.required::after {
    content: '*';
    margin-left: 2px;
  }

  .list-i.noPad {
    padding: 0;
    background-color: #fff;
  }

  .empty {
    background-color: var(--grey-bg);
    line-height: 30px;
    padding: 0 8px;
    color: var(--grey-medium);
    font-style: italic;
  }

  .list-i.compact .key {
    width: 100px;
    overflow-wrap: break-word;
    margin-right: 8px;
  }
</style>
